import React, { Component } from 'react';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { CommonValidationMessages } from "../../../utils/Messages";
import moment from "moment";
import { GeneralAccountHeadPopup } from './GeneralAccountHeadTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { permission } from '../../../utils/enums/ValidationMessage';
import { Navigate } from 'react-router-dom';
import { decryptAES } from '../../../utils/Encryption';

export default class GeneralAccountHead extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.state = {
            urlId: 0,
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            expenseLedgerObject: {
                idGeneralProduct: 0,
                updateStatus: 0,
                srNo: "",
                selectedAccGrp: {},
                //accGrp: "",
                selectedAccHead: {},
                expLedgerName: "",
                ledgerCode: "",
                e_Date: "",
                openingBalanceDate: "",
                openingBalance: "",
                balanceTypeId: 1,
                balanceTypeName: 'CREDIT',
                isCarryForward: false,
                selectedbalanceType: {},
                types: [
                    {
                        value: 1,
                        label: "CREDIT",
                    },
                    {
                        value: 2,
                        label: "DEBIT",
                    }
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                expLedgerName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "expense ledger name"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.setState({ isModalOpen: true }, () => {

        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMasterAccountHeadSelectbyID(event.data.idGeneralProduct);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState })
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.expenseLedgerObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
            this.resetDetailsFields()
        });
    };
    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: false, }, () => {
            this.resetDetailsFields()
        });
    };

    handleChange = (event, name) => {
        let details = this.state.expenseLedgerObject;
        if (name === 'balanceType') {
            details.balanceTypeId = event.value;
            details.balanceTypeName = event.label;
        } else if (name === 'isCarryForward') {
            let checked = event.target.checked
            details.isCarryForward = checked
        } else {
            let value = event.target.value;
            details[name] = value;
        }
        this.setState({ expenseLedgerObject: details });
    }

    setFilterParameters = (selected, drpIdentity) => {
        let details = this.state.expenseLedgerObject;
        details[drpIdentity] = selected;
        if (drpIdentity === 'selectedAccHead') {
            details.selectedAccGrp = selected.accountGroupId ? this.state.expenseLedgerObject.accGrpList.find(x => x.value === selected.accountGroupId) : {}
        }
        this.setState({ expenseLedgerObject: details });
    };

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let accountObject = this.state.expenseLedgerObject;
        accountObject.idGeneralProduct = 0;
        accountObject.updateStatus = 0;
        accountObject.srNo = "";
        accountObject.selectedAccGrp = {};
        accountObject.selectedAccHead = {};
        accountObject.expLedgerName = "";
        accountObject.ledgerCode = "";
        accountObject.e_Date = "";
        accountObject.openingBalance = '';
        accountObject.openingBalanceDate = '';
        accountObject.balanceTypeId = 1;
        accountObject.balanceTypeName = 'CREDIT';
        accountObject.selectedbalanceType = {};
        accountObject.isCarryForward = false;
        this.setState({
            expenseLedgerObject: accountObject, validState: validState
        }, () => {
            this.usp_Master_GeneralAccountHeadCount();
        });
    }

    componentDidMount = () => {

        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }


        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                //this.getMasterExpenseAccGroupCount();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }
    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "General Account Head",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idGeneralProduct"].includes(key) ? true : false,
                            // width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.getMasterAccountHeadSelect();
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "Expense Ledger Account",
                            colName: colName
                        }, () => {
                            this.usp_Master_GeneralAccountHeadCount();
                            this.setPermissions(permissions);

                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        this.usp_Master_GeneralAccountHeadCount();
                        this.getMasterAccountHeadSelect();
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                            // this.getAllDropdownForEmployeeMaster();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.expenseLedgerObject;
        details.idGeneralProduct = id;
        this.setState({ expenseLedgerObject: details }, () => {
            this.getMasterAccountHeadSelectbyID(this.state.expenseLedgerObject.idGeneralProduct);
        });
    };

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }
    getColumnWidth = (key) => {
        const colwidth = {
            "idGeneralProduct": window.innerWidth * 0.04,
            "sR.No": window.innerWidth * 0.04,
            "accountGroup": window.innerWidth * 0.15,
            "accountHead": window.innerWidth * 0.2,
            "accountSubHead": window.innerWidth * 0.5,
        }
        return colwidth[key]
    }

    usp_Master_GeneralAccountHeadCount = () => {
        //this.accountMasterServices.getMasterExpenseAccGroupCount(this.state.idCompany).then((response) => {
        //debugger
        //if (response.statusCode == 200 && response.responseItem !== null) {
        let list = this.state.rowData;
        let maxIdPaymentMake = list.length > 0
            ? list.length
            : 0;
        let srNo = String(maxIdPaymentMake + 1); //.padStart(3, '0');
        let data = this.state.expenseLedgerObject;
        data.srNo = srNo;
        this.setState({
            expenseLedgerObject: data
        });
        //}
        //});
    }

    getMasterAccountHeadSelect = () => {
        this.accountMasterServices.getMasterAccountHeadSelect().then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idAccountHead,
                    label: x.accountHead,
                    accountGroupId: x.idAccountGroup
                }));
                let object = this.state.expenseLedgerObject
                object.accHeadList = data;
                this.setState({
                    expenseLedgerObject: object
                }, () => {
                    this.getMasterExpenseAccountGroupSelect();
                });
            }
        });
    }

    getMasterExpenseAccountGroupSelect = () => {
        this.accountMasterServices.getMasterExpenseAccountGroupSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idAccountGroup,
                    label: x.accountGroup,
                }));
                let object = this.state.expenseLedgerObject
                object.accGrpList = data;
                this.setState({
                    expenseLedgerObject: object
                }, () => {
                    // this.getMasterExpenseAccountGroupSelect();
                });
            }
        });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            //let data = this.state.ledgerDetails;
            let data = this.state.expenseLedgerObject;

            let requestData = {
                idGeneralProduct: data.idGeneralProduct,
                //idAccountGroup: data.selectedAccGrp.value,
                idAccountHead: data.selectedAccHead.value,
                productName: data.expLedgerName,
                productCode: data.ledgerCode,
                e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                openingBalance: Number(data.openingBalance),
                opBalanceDate: (data.openingBalanceDate && data.openingBalanceDate !== 'Invalid date') ? data.openingBalanceDate : null,
                balanceType: data.balanceTypeName,
                isCarryForward: data.isCarryForward,
                isDeleted: false,
                idCompany: this.state.idCompany,
            };
            this.accountMasterServices.submitGeneralAccountHeadMaster(requestData).then((response) => {
                //debugger
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData !== null) {
                        if (this.state.expenseLedgerObject.updateStatus === 1) {
                            this.SwalServices.Success("Updated sucessfully.");
                        } else {
                            this.SwalServices.Success("Save sucessfully.");
                        }
                        if (this.state.urlId) {
                            this.setState({ route: '/ledger-report' });
                        } else {
                            this.setState({
                                isModalOpen: false,
                            }, () => {
                                this.procSelectAllRecordsSP();
                                this.resetDetailsFields();
                            });
                        }
                    } else {
                        this.procSelectAllRecordsSP();
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    getMasterAccountHeadSelectbyID = (id) => {
        //const isValidAllFields = this.isValidAllFields();
        //if (isValidAllFields) {
        //let data = this.state.ledgerDetails;
        //let data = this.state.accountHeadObject;
        this.accountTransactionServices.getGeneralProductSelectbyID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent[0];
                let data = this.state.expenseLedgerObject;
                data.idGeneralProduct = dynamicData.idGeneralProduct;
                data.updateStatus = 1;
                data.srNo = dynamicData.idGeneralProduct;
                // data.selectedAccGrp = dynamicData.idAccountGroup > 0 ? data.accGrpList?.find(item => item.value === dynamicData.idAccountGroup) : {};
                //data.//accGrp = "";
                data.selectedAccHead = dynamicData.idAccountHead > 0 ? data.accHeadList?.find(item => item.value === dynamicData.idAccountHead) : {};
                data.selectedAccGrp = data?.selectedAccHead?.accountGroupId > 0 ? data.accGrpList?.find(item => item.value === data.selectedAccHead.accountGroupId) : {}
                data.expLedgerName = dynamicData.productName;
                data.ledgerCode = dynamicData.productCode;
                data.e_Date = dynamicData.e_Date;
                data.openingBalance = dynamicData.openingBalance ? dynamicData.openingBalance : '';
                data.openingBalanceDate = moment(dynamicData.opBalanceDate).format('YYYY-MM-DD');
                data.currentBalance = dynamicData.currentBalance;
                data.balanceTypeName = dynamicData.balanceType;
                data.balanceTypeId = dynamicData.balanceType ? data.types?.find(item => item.label === dynamicData.balanceType)?.value : "";
                data.selectedbalanceType = dynamicData.balanceType ? data.types?.find(item => item.label === dynamicData.balanceType) : {};
                data.isCarryForward = dynamicData.isCarryForward
                this.setState({
                    isModalOpen: true,
                    expenseLedgerObject: data
                });
            } else {
                this.SwalServices.Error(response.message);
            }
        });
        //}
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='acc-head-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <GeneralAccountHeadPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            expenseLedgerObject={this.state.expenseLedgerObject}
                            handleChange={this.handleChange.bind(this)}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Expense ledger account</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}